<template>
  <!-- 数据大厅详情 -->
  <div class="dataset-preview">
    <gat-head class="training-head"></gat-head>
    <div class="preview-container">
      <div class="nav-head">
        <!-- <div>数据集大厅</div> -->
        <div class="nav-head-left">
          <el-breadcrumb separator-class="el-icon-arrow-right" v-if="datasetPageType != 2">
            <el-breadcrumb-item :to="{ path: '/pretrain/datasetlobby', query: {searchType: '0'} }">数据集大厅</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/pretrain/datasetlobby', query: {searchType: searchType} }">
              {{searchType == 0 ? '公开数据集' : searchType == 1 ? '个人数据集' : '我的收藏'}}
            </el-breadcrumb-item>
            <el-breadcrumb-item>数据集详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="nav-head-right">
          <div class="go-to-dataset" @click="onBlackModel" v-if="datasetPageType == 2">
            <i class="el-icon el-icon-right"></i>
            <span>返回</span>
          </div>
          <router-link class="go-to-dataset" :to="{ name: 'pretrain' }" v-else>
            <i class="el-icon el-icon-right"></i>
            <span>前往模型训练</span>
          </router-link>
        </div>
      </div>

      <!-- 数据集列表 -->
      <dataset-list-card
        :datasetPageType="datasetPageType"
        :searchType="searchType"
        :datasetData="datasetData"
        @getDatasetList="getDatasetList"
      ></dataset-list-card>
      <!-- 文件列表 -->
      <dataset-file-list
        :datasetPageType="datasetPageType"
        :searchType="searchType"
        :datasetId="datasetId"
        :datasetName="datasetName"
        :datasetType="datasetType"
        :modelDatasetId="modelDatasetId"
        :labelId="labelId"
        :modFileNum="modFileNum"
        @getDatasetList="getDatasetList"
        @onBlackModel="onBlackModel"
      ></dataset-file-list>
    </div>
  </div>
</template>

<script>
import DATASETLOBBY from '@/axios/datasetLobby/datasetLobby.js'
// import PRETRAIN from '@/axios/pretrain/pretrain.js'

import DatasetListCard from './components/DatasetListCard.vue'
import DatasetFileList from './components/DatasetFileList.vue'

export default {
  name: "dataset-preview",
  components: { DatasetListCard, DatasetFileList },
  props: {},
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
      searchType: '0', // nav类型：0公开数据集，1个人数据集，2我的数据集
      datasetId: '', // 当前数据集id
      datasetName: '', // 当前数据集名称
      datasetType: '1', // 数据集类型：1图像分类，2图像检测，3文本分类，4文本标注，5音频分类，6音频标注
      isAdd: 0, // 增加一次查看数：0不增，1增加
      datasetPageType: 1, // 数据页面类型：0数据大厅, 1数据大厅详情，2引用数据集详情
      modelDatasetName: '', // 模型/目标数据集名称
      modelDatasetId: '', // 模型/目标数据集id
      labelId: '', // 分类标签id
      modFileNum: 0, // 目标数据集文件数
      datasetData: {
        records: [],
        size: 10,
        currentPage: 1,
        total: 0
      },
    }
  },
  computed: {
  },
  created() {
    this.searchType = this.$route.query.searchType || '0'
    this.datasetId = this.$route.query.datasetId || ''
    this.datasetName = this.$route.query.datasetName || ''
    this.datasetType = this.$route.query.datasetType || ''
    this.isAdd = Number(this.$route.query.isAdd) || 0
    this.datasetPageType = Number(this.$route.query.datasetPageType) || 1 // 默认1为数据集大厅详情页
    this.modelDatasetName = this.$route.query.modelDatasetName || ''
    this.modelDatasetId = this.$route.query.modelDatasetId || ''
    this.labelId = this.$route.query.labelId || ''
    this.modFileNum = Number(this.$route.query.modFileNum) || 0
    
    this.getDatasetInfoByDatasetId() // 根据数据集id获取数据集详情
    
    setTimeout(() => {
      // 判断数据大厅进入详情增加一次查看数
      if (this.isAdd) {
        this.isAdd = 0
        // 更改路由参数不刷新页面
        this.$router.push({
          name: "dataset-preview",
          query: {
            searchType: this.searchType, // nav类型：0公开数据集，1个人数据集，2我的数据集
            datasetId: this.datasetId, // 当前数据集id
            datasetName: this.datasetName, // 当前数据集名称
            datasetType: this.datasetType, // 数据集类型：1图像分类，2图像检测，3文本分类，4文本标注，5音频分类，6音频标注
            isAdd: 0, // 增加一次查看数：0不增，1增加
            datasetPageType: this.datasetPageType, // 数据页面类型：0数据大厅,1数据大厅详情，2引用数据集详情
            modelDatasetName: this.modelDatasetName, // 模型/目标数据集名称
            modelDatasetId: this.modelDatasetId, // 模型/目标数据集id
            labelId: this.labelId, // 分类标签id
            modFileNum: this.modFileNum, // 目标数据集文件数
          }
        });
      }
    }, 10);
  },
  methods: {
    getDatasetList() {
      // 文件列表改变刷新数据集详情信息，当前页面进程最后执行、避免查看数增加。
      setTimeout(() => {
        this.getDatasetInfoByDatasetId()
      }, 500);
    },
    // 根据数据集id获取数据集详情
    getDatasetInfoByDatasetId() {
      let data = {
        datasetHallType: this.searchType,
        datasetId: this.datasetId,
        datasetName: this.datasetName,
        isAdd: this.isAdd // 是否增加查看数：0为不增加 1为增加
      }
      DATASETLOBBY.getDatasetInfoByDatasetId(data).then(result => {
        if (result.isSuccess) {
          let list = []
          list.push(result.data)
          this.datasetData.records = list
        } else {
          this.$message.error(result.returnMsg);
          this.datasetData = {
            records: [],
            size: 10,
            currentPage: 1,
            total: 0
          }
          if (result.returnCode == 501) { // 501：数据集不存在
            if (this.datasetPageType == 2) {
              // 返回模型训练
              this.onBlackModel()
            } else {
              // 返回数据大厅
              this.$router.push({
                name: "dataset-lobby",
                query: { searchType: this.searchType }
              });
            }
          }
        }
      }).catch(() => {
        this.datasetData = {
          records: [],
          size: 10,
          currentPage: 1,
          total: 0
        }
      });
    },
    // 返回模型训练
    onBlackModel() {
      let pathType = ''
      if (this.datasetType == 1) {
        pathType = 'dataset/classify'
      } else if (this.datasetType == 2) {
        pathType = 'dataset/label'
      } else if (this.datasetType == 3) {
        pathType = 'dataset/textCategorization'
      } else if (this.datasetType == 4) {
        pathType = 'dataset/textAnnotation'
      } else if (this.datasetType == 5) {
        pathType = 'dataset/audioCategorization'
      } else if (this.datasetType == 6) {
        pathType = 'dataset/audioAnnotation'
      }
      // 去到模型训练
      this.$router.push({
        path: `/pretrain/${this.datasetType}/${pathType}`,
        query: { 
          modelType: this.datasetType, // 模型训练类型
          datasetName: this.modelDatasetName, // 模型训练数据集名称
          datasetId: this.modelDatasetId, // 模型训练数据集id
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
$main_height: calc(100% - 80px);

.dataset-preview {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: $background_normal_color;
  padding: 80px 0 60px;

  .preview-container {
    width: 1200px;
    min-height: $main_height;
    margin: 0 auto;
    .nav-head {
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      .nav-head-left {
        flex: 1;
        .el-breadcrumb {
          font-size: 12px;
          ::v-deep.el-breadcrumb__inner {
            color: #919BB3;
          }
          ::v-deep.el-breadcrumb__inner.is-link {
            &:hover {
              color: #4c88ff;
            }
          }
        }
      }
      .nav-head-right {
        .go-to-dataset {
          color: #4c88ff;
          font-size: 14px;
          font-weight: bold;
          cursor: pointer;
          .el-icon-right {
            margin-right: 5px;
            font-weight: bold;
          }
        }
      }
    }

    .dataset-file-list {
      margin-top: 20px;
    }
  }
}

</style>
